import React from "react";
import { fontSize, styled } from "@mui/system";
import { TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment/moment";
const CustomDateTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#F4F5F9",
    borderRadius: "4px",
    fontSize: "12px",
    "& fieldset": {
      borderColor: "#DBDCDE", // Default border color
    },
    "&:hover fieldset": {
      borderColor: "#DBDCDE", // Hover border color
    },
    "&.Mui-focused fieldset": {
      borderColor: "#DBDCDE", // Focused border color
    },
  },
  "& .MuiInputBase-input": {
    color: "#89868D", // Input text color
  },
}));
function CustomTextField(params) {
  return <CustomDateTextField size="small" fullWidth {...params} />;
}
const SiDatePicker = ({
  value = null,
  onChange,
  error,
  placeholder,
  minDate,
  maxDate,
  ...props
}) => {
  // let formattedDate = "";
  // const formatVal = moment(value).format("DD-MM-YYYY");
  // const inputFormat = "DD-MM-YYYY";
  // const outputFormat = "DD/MM/YYYY";
  // const isValid = dayjs(formatVal, inputFormat, true).isValid();
  // if (isValid) {
  //   formattedDate = dayjs(formatVal, inputFormat).format(outputFormat);
  // }
  // console.log(value, isValid, formatVal);

  const inputFormat = "DD-MM-YYYY";
  const outputFormat = "DD/MM/YYYY";

  // Function to validate DD-MM-YYYY format correctly
  const isValidDDMMYYYY = (dateStr) => {
    const regex = /^([0-2][0-9]|3[0-1])-(0[1-9]|1[0-2])-(\d{4})$/; // Ensures correct DD-MM-YYYY format
    return regex.test(dateStr) && moment(dateStr, inputFormat, true).isValid();
  };

  // Check if the value is already in DD-MM-YYYY format
  const isAlreadyFormatted = isValidDDMMYYYY(value);

  // Use value directly if it's valid, otherwise format it
  const formattedDate = isAlreadyFormatted
    ? value
    : moment(value).format(inputFormat);

  const isValid = isValidDDMMYYYY(formattedDate);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DesktopDatePicker
        value={(isValid && dayjs(formattedDate, outputFormat)) || null}
        format="DD/MM/YYYY"
        onChange={onChange}
        minDate={minDate && minDate}
        maxDate={maxDate && maxDate}
        {...props}
        slots={{
          textField: CustomTextField,
        }}
      />
    </LocalizationProvider>
  );
};

export default SiDatePicker;
